import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  travelCount: 1,
};

const travelCountSlice = createSlice({
  name: "travelCount",
  initialState,
  reducers: {
    incrementTravelCount: (state) => {
      state.travelCount++;
    },
    decrementTravelCount: (state) => {
      if (state.travelCount > 1) {
        state.travelCount--;
      }
    },
  },
});

export const { incrementTravelCount, decrementTravelCount } =
  travelCountSlice.actions;
export default travelCountSlice.reducer;
